export { I18n, i18n } from './i18n';
